import FeedbackWrittenTestimonialPage from './FeedbackWrittenTestimonialPage'

export default FeedbackWrittenTestimonialPage
